import { CONSTANTS } from "client/utils/constants";
import OrderType from "./OrderType";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getAssetType } from "Store/AssetManagement/AssetType/AssetTypeAction";
import { getBulkOrderCostCenter } from "Store/Organization/CostCenters/CostCentersAction";
import { setIsApprovalOverride, setOrderCartData, setOrderData, setSelectedCostCenter, setSelectedOrderType } from "Store/Component/BulkOrder/BulkOrderAction";
import ConfirmationBee from "../../../../../assets/images/ConfirmationBee.svg"
import rejectedBee from '../../../../../assets/images/PenndingApproval/Rejected Bee.png'
import selectors from "redux/Navigation/selectors";
import pendingOrderOperations from 'redux/PendingOrder/operations';
import RequisitionAction from 'Store/Component/Requisition/RequisitionAction';
import userProfileSelectors from 'redux/UserProfile/selectors'
import { useNavigate, useParams } from "react-router-dom";
import { operations as navigationOperations } from "redux/Navigation";
import navOperations from "redux/Navigation/operations";
import OrderDispatch from 'Store/OrderManagement/Order/OrderDispatch'
import { setDeleteCartOrder } from "Store/OrderManagement/Order/OrderAction";
import TransferAction from "Store/Component/Transfer/TransferAction";

const OrderTypeContainer = (props: any) => {

    const dispatch = useDispatch();
    const navigate = useNavigate()
    let { id } = useParams();

    const [orderTypeDropdownList, setOrderTypeDropdownList] = useState<any>({})
    const [costCenterDropdownList, setCostCenterDropdownList] = useState<any>({})
    const [validation, setValidation] = useState<any>({})
    const cancelOrderRequest = pendingOrderOperations.dispatchCancelOrderRequest(dispatch);
    const dispatchActionPopupValue = pendingOrderOperations.dispatchActionPopup(dispatch);
    const navDispatch = navigationOperations.dispatchNav(dispatch);
    const dispatchHeaderNav = navOperations.dispatchHeaderNav(dispatch);
    const [isCancelClicked, setIsCancelClicked] = useState<any>(false);
    const dispatchGetDeleteCartOrderById = OrderDispatch.dispatchGetDeleteCartOrder(dispatch);

    const {
        requisitionTypeList,
        bulkOrderCostCenterList,
        selectedCostCenter,
        selectedOrderType,
        isApprovalOverride,
        orderDetails,
        BulkOrdeByIdValue = [],
        headerNav,
        isOrderCanceled,
        userDetails,
        cartOrderDelete,
        isCostCenterAvailableForSubmit
    }: any = useSelector(
        (state: any) => ({
            requisitionTypeList: state.AssetManagement.AssetType,
            bulkOrderCostCenterList: state.CostCentersReducer.bulkOrderCostCenterList,
            selectedCostCenter: state.BulkOrderReducer.selectedCostCenter,
            selectedOrderType: state.BulkOrderReducer.selectedOrderType,
            isApprovalOverride: state.BulkOrderReducer.isApprovalOverride,
            orderDetails: state.BulkOrderReducer.orderDetails,
            BulkOrdeByIdValue: state.BulkOrdeByIdReducer.bulkOrderbyIdValue,
            headerNav: selectors.GetHeaderNav(state),
            isOrderCanceled: state.PendingOrder.isOrderCanceled,
            userDetails: userProfileSelectors.getUserDetails(state),
            cartOrderDelete: state.OrderReducer.cartOrderDelete,
            isCostCenterAvailableForSubmit: state.TransferReducer.isCostCenterAvailableForSubmit
        })
    )

    const [Popupcontent, setPopupcontent] = useState<any>({
        title: "",
        isDialogVisible: false,
        isTitleWarning: false,
        subtextcontent: "",
        primaryBtnText: "",
        outlineBtnText: "",
        isSingleConfirmationBtn: false,
        isCommentboxVisible: false,
        isCompletedReportVisible: false,
        titleImg: "",
        isCommentBoxRequire: false,
        outlineBtnnavigateTo: "",
        primaryBtnnavigateTo: "",
        popupOutlinebtnOnclick:()=>{},
        popupPrimarybtnOnclick:()=>{},
        actionby: "",
        value: 0,
        comment: "",
      });

    interface VehicleRequest {
        selectedVehicleType: {} | null | undefined;
        selectedMake: {} | null | undefined;
        quantityVehicle: number;
        selectedSpec: {} | null | undefined;
        requestIndex: number;
        attachments: [] | undefined;
        comment: string;
        orderRequestSubTypeId: number;
        orderRequestSubTypeLabel: string;
        orderTypeId: number;
        equipmentIndex: number;
        selectedVehicleTypeError: string;
        selectedMakeError: string;
        quantityVehicleError: string;
        selectedSpecError: string;
    }

    interface ManagedEquipementRequest {
        requestType: string;
        selectedEquipementType: {} | null | undefined;
        selectedEquipementTypeError: string;
        searchCriteria: {} | null | undefined;
        selectedCatalogItems: [] | null | undefined;
        requestIndex: number;
        orderTypeId: number;
        equipmentIndex: number;
        attachments: [] | undefined;
    }

    const vehicaleData: VehicleRequest = {
        selectedVehicleType: {},
        selectedMake: '',
        quantityVehicle: 1,
        selectedSpec: {},
        requestIndex: 0,
        equipmentIndex: 0,
        comment: '',
        attachments: [],
        orderRequestSubTypeId: 0,
        orderRequestSubTypeLabel: "Vehicle Request",
        orderTypeId: 0,
        selectedVehicleTypeError: '',
        selectedMakeError: '',
        quantityVehicleError: '',
        selectedSpecError: ''
    }

    const managedEquipementData: ManagedEquipementRequest = {
        requestType: '',
        selectedEquipementType: {},
        selectedEquipementTypeError: '',
        searchCriteria: {},
        selectedCatalogItems: [],
        requestIndex: 0,
        orderTypeId: 0,
        equipmentIndex: 0,
        attachments: []
    }

    useEffect(() => {
        if (id) {
            if (bulkOrderCostCenterList?.length && selectedCostCenter?.text) {
                if (bulkOrderCostCenterList?.filter((branchItem: any) => branchItem?.text === selectedCostCenter?.text).length > 0) {
                    dispatch(TransferAction?.setIsCostCenterAvailableForSubmit(true))
                } else {
                    dispatch(TransferAction?.setIsCostCenterAvailableForSubmit(false))
                }
            }
        } else {
            dispatch(TransferAction?.setIsCostCenterAvailableForSubmit(true))
        }
    }, [bulkOrderCostCenterList, selectedCostCenter])

    const navigateBack = () => {
        if (headerNav == "Home") {
          navigate('/ordermanagement')
          navDispatch('Home');
          dispatchHeaderNav('Home');
        } else {
          navigate('/ordermanagement')
          navDispatch('Bulk Orders');
          dispatchHeaderNav('Bulk Orders');
        }
      } 

    const cancelOrderReq = () => {
        const cancelOrdersubtext = (
            <>
              <p>Are you sure you want to cancel the Order</p>
              <p>
              <b>LEADR Order # : </b>{id}
              </p>
            </>
          );
        setPopupcontent({
          ...Popupcontent,
          titleImg: rejectedBee,
          title: "CANCEL ORDER",
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: cancelOrdersubtext,
          primaryBtnText: "Yes",
          outlineBtnText: "No",
          isSingleConfirmationBtn: false,
          isCommentboxVisible: true,
          isCommentBoxRequire: true,
          isCompletedReportVisible: false,
          outlineBtnnavigateTo: "",
          primaryBtnnavigateTo: headerNav ,
          actionby: "CancelOrderBtn",
          popupOutlinebtnOnclick: () => {
            hideDialog();
            setIsCancelClicked(false)
            dispatchActionPopupValue({})
            isOrderCanceled.approval = null;
        },
        popupPrimarybtnOnclick: (item: any,
            comment: string,
            actionby: string,
            value: any) => {
            if (BulkOrdeByIdValue?.orderStatus == "Saved") {
                const deleteDraftOrder = {
                    orderId: BulkOrdeByIdValue?.orderId,
                    comments: comment,
                    savedBy: userDetails?.emailId
                };
                dispatchGetDeleteCartOrderById(deleteDraftOrder)
            } else {
                cancelOrderRequest({ orderId: id, savedBy: userDetails?.emailId, comments: comment });
            }
                dispatchActionPopupValue({
                  actionby: actionby
                });
                setIsCancelClicked(true)
                hideDialog();
        }
        });
      };

      useEffect(() => {
        if (((isOrderCanceled?.approval && isOrderCanceled?.approval != null) || (cartOrderDelete && cartOrderDelete != null)) && isCancelClicked) {
          dispatch(RequisitionAction.setIsChangesOccured(false))
          let decriptionTxt = (
            <p>Order Cancelled Successfully</p>
          );
          setPopupcontent({
            ...Popupcontent,
            titleImg: rejectedBee,
            title: "CANCEL ORDER",
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: decriptionTxt,
            outlineBtnText: "Close",
            isSingleConfirmationBtn: true,
            isCommentboxVisible: false,
            isCommentBoxRequire: false,
            popupOutlinebtnOnclick: () => {
                hideDialog();
                dispatchActionPopupValue({})
                isOrderCanceled.approval = undefined;
                dispatch(setDeleteCartOrder(null));
                navigateBack()
                setIsCancelClicked(false)
            },
          });
        }
        else if(((isOrderCanceled?.approval != null && isOrderCanceled?.approval != undefined) || (!cartOrderDelete && cartOrderDelete != null)) && !isOrderCanceled?.approval && isCancelClicked) {
            let decriptionTxt = (
                <p>Error occured while cancelling the order.</p>
              );
              setPopupcontent({
                ...Popupcontent,
                titleImg: ConfirmationBee,
                title: "INFORMATION",
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                outlineBtnText: "Close",
                isSingleConfirmationBtn: true,
                isCommentboxVisible: false,
                isCommentBoxRequire: false,
                popupOutlinebtnOnclick: () => {
                    hideDialog();
                    dispatchActionPopupValue({})
                    isOrderCanceled.approval = undefined;
                    dispatch(setDeleteCartOrder(null));
                    setIsCancelClicked(false)
                }
              });
        }
      }, [isOrderCanceled?.approval, cartOrderDelete])

    useEffect(() => {
         dispatch(getAssetType(true));
        dispatch(getBulkOrderCostCenter())
    }, []);

    useEffect(() => {
        const dropdownList = requisitionTypeList?.map((item: any)=>({    
            ...item,
            label: item?.orderRequestType,
            value: item?.orderRequestType,
            key: item?.orderRequestTypeId
        }))
        setOrderTypeDropdownList(dropdownList)
    }, [requisitionTypeList])

    useEffect(() => {
        const dropdownList = bulkOrderCostCenterList?.map((item?: any) => {
            return { label: item.text, key: item?.value, ...item }
        })
        setCostCenterDropdownList(dropdownList)
    }, [bulkOrderCostCenterList])

    const onChangeOrderType = (item: any) => {
        setValidation({ ...validation, orderTypeError: "" });
        dispatch(setSelectedOrderType(item))
    }

    const onChangeCostCenter = (item: any) => {
        if (props?.showOrderTypeDetail) {
            setPopupcontent({
                ...Popupcontent,
                titleImg: ConfirmationBee,
                title: "CONFIRMATION",
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: <><p>Are you sure to change Branch?</p><p>Already entered details will be removed.</p></>,
                primaryBtnText: "Yes",
                outlineBtnText: "No",
                isSingleConfirmationBtn: false,
                popupOutlinebtnOnclick: () => {
                    hideDialog();
                },
                popupPrimarybtnOnclick: () => {
                    hideDialog();
                    props?.setShowOrderTypeDetail(false)
                    props?.setShowCart(false)
                    dispatch(setOrderData([]))
                    dispatch(setOrderCartData([]))
                    dispatch(setSelectedOrderType({}))
                    dispatch(setSelectedCostCenter(item))
                    dispatch(setIsApprovalOverride(false))
                }
              });
        }else{
            setValidation({ ...validation, costCenterError: "" });
            dispatch(setSelectedCostCenter(item))
        }
    }

    const hideDialog = () => setPopupcontent({ ...Popupcontent, isDialogVisible: false });

    const onAddItemClick = () => {
        const isValid = Validation()
        if (isValid) {
            props?.setShowOrderTypeDetail(true)
            if (selectedOrderType?.label == CONSTANTS.VEHICLE_REQUEST) {
                props?.setShowVehicleRequest(true)
                let nextIndex = orderDetails?.length ? Math.max(...orderDetails.map((req: any) => req.requestIndex)) + 1 : 1
                let sortedRequest = [...(orderDetails || []), {...vehicaleData, requestIndex: nextIndex, equipmentIndex: nextIndex, requestType: CONSTANTS?.VEHICLE_REQUEST, orderTypeId: selectedOrderType?.key}]?.sort((a: any,b: any) => b?.requestIndex - a?.requestIndex)
                dispatch(setOrderData(sortedRequest))

            }else if (selectedOrderType?.label == CONSTANTS.MANAGED_EQUIPMENT) {
                props?.setEquipmentRequest(true)
                let nextIndex = orderDetails?.length ? Math.max(...orderDetails.map((req: any) => req.requestIndex)) + 1 : 1
                let sortedRequest = [...(orderDetails || []), {...managedEquipementData, requestIndex: nextIndex, requestType: CONSTANTS?.MANAGED_EQUIPMENT, orderTypeId: selectedOrderType?.key}]?.sort((a: any,b: any) => b?.requestIndex - a?.requestIndex)
                dispatch(setOrderData(sortedRequest))
            }
        }
    }

    const Validation = () => {
        let error = { ...validation }
        let isValid = true;
        if (!selectedCostCenter?.value) {
            error.costCenterError = "Please select Cost Center";
            isValid = false
        } else {
            error.costCenterError = ""
        }
        if (!selectedOrderType?.value) {
            error.orderTypeError = "Please select Order Type";
            isValid = false
        } else {
            error.orderTypeError = ""
        }
        setValidation(error);
        return isValid;
    }

    const handlePreAuthorizedFlagChange = (e: any, value: any) => {
       dispatch(setIsApprovalOverride(value))
    }

    return (
        <OrderType
            orderTypeDropdownList={orderTypeDropdownList}
            costCenterDropdownList={costCenterDropdownList}
            onChangeCostCenter={onChangeCostCenter}
            onChangeOrderType={onChangeOrderType}
            selectedCostCenter={selectedCostCenter}
            selectedOrderType={selectedOrderType}
            onAddItemClick={onAddItemClick}
            validation={validation}
            BulkOrdeByIdValue  = {BulkOrdeByIdValue}
            Popupcontent={Popupcontent}
            hideDialog={hideDialog}
            isApprovalOverride = {isApprovalOverride}
            handlePreAuthorizedFlagChange = {handlePreAuthorizedFlagChange}
            cancelOrderReq = {cancelOrderReq}
            isCostCenterAvailableForSubmit = {isCostCenterAvailableForSubmit}
        />
    )
}

export default OrderTypeContainer;